import React, { Component } from 'react';
import { FaCircleNotch } from 'react-icons/fa';
import styled from 'styled-components';

const FooterButtonContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  padding: ${(props) => (props.noPadding ? '0' : '20px 16px')};
  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  // border-top: 1px solid #eee;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 80%,
    rgba(255, 255, 255, 0.2) 100%
  );
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 10;
  max-width: 440px;
  // left: ${(props) => (props.left ? '0' : '')};
`;

const FooterBody = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
`;

const ButtonDiv = styled.div`
  width: 100%;
  background: ${(props) =>
    !props.disabled ? 'var(--primary-button)' : '#e3e3e3'};
  display: flex;
  justify-content: ${(props) =>
    props.leftSideButtonText ? 'space-between' : 'center'};
  padding: ${(props) => (props.leftSideButtonText ? '15px 20px' : '')};
`;

const FooterButtonText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: ${(props) => (!props.disabled ? '#0f0b28' : '#aaa')};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LoadingIcon = styled(FaCircleNotch)`
  color: white;
  margin-right: 0.5rem;
`;

const FooterButton = ({
  disabled,
  onClick,
  buttonText,
  noPadding,
  bg,
  leftSideButtonText,
  shadowStyle,
  loading,
}) => (
  <FooterButtonContainer
    style={shadowStyle || {}}
    noPadding={noPadding}
    bg={bg}
  >
    <FooterBody>
      <ButtonDiv
        disabled={disabled}
        className="rounded-12 py-16px"
        onClick={() => {
          !loading && !disabled && onClick();
        }}
        leftSideButtonText={leftSideButtonText}
      >
        {leftSideButtonText && (
          <FooterButtonText disabled={disabled}>
            {leftSideButtonText}
          </FooterButtonText>
        )}
        <FooterButtonText disabled={disabled}>
          {buttonText}
          {loading ? <LoadingIcon className="icon-spin" /> : null}
        </FooterButtonText>
      </ButtonDiv>
    </FooterBody>
  </FooterButtonContainer>
);

export default FooterButton;
